import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { TopNav } from "@/components/TopNav";
import { HeroSection } from "@/components/HeroSection";
import { PillarsGrid } from "@/components/PillarsGrid";
import { AboutSection } from "@/components/AboutSection";
import { TournamentCalendar } from "@/components/TournamentCalendar";
import { InviteLeaderboard } from "@/components/InviteLeaderboard";
import { BadgeCelebration, useBadgeUnlock } from "@/components/BadgeCelebration";
import { OneIdSection, Footer } from "@/components/Footer";
import { OneTalantaIDAuthModal } from "@/components/OneTalantaIDAuthModal";
import { UserProfileModal } from "@/components/UserProfileModal";
import { SportLiveEngineModal } from "@/components/SportLiveEngineModal";
import { LaunchingSoonModal } from "@/components/LaunchingSoonModal";
import { NextGenPillarModal } from "@/components/NextGenPillarModal";

export default function Home() {
  const { user } = useAuth();
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("create");
  const [prefillPhone, setPrefillPhone] = useState("");
  const [profileOpen, setProfileOpen] = useState(false);
  const [sportOpen, setSportOpen] = useState(false);
  const [launchPillar, setLaunchPillar] = useState(null);
  const [nextGenPillar, setNextGenPillar] = useState(null);
  const [params, setParams] = useSearchParams();
  const [unlock, clearUnlock] = useBadgeUnlock();

  useEffect(() => {
    const ref = params.get("ref");
    if (ref && /^TH-[A-Z0-9_-]{6,16}$/i.test(ref)) {
      localStorage.setItem("th_ref", ref.toUpperCase());
      toast(`You've been invited by ${ref.toUpperCase()} — create your One Talanta ID to join them.`, { duration: 7000 });
      const next = new URLSearchParams(params);
      next.delete("ref");
      setParams(next, { replace: true });
      if (!user) setTimeout(() => setAuthOpen(true), 400);
      return;
    }
    if (params.get("linked")) {
      setProfileOpen(true);
      setParams({}, { replace: true });
    }
    if (params.get("signin") !== null) {
      openAuth("", "signin");
      setParams({}, { replace: true });
    }
  }, [params, setParams, user]);

  const openAuth = (phone = "", mode = "create") => {
    setPrefillPhone(phone);
    setAuthMode(mode);
    setAuthOpen(true);
  };

  return (
    <div className="min-h-screen bg-talanta-cream">
      <TopNav onLogin={() => openAuth()} onSignin={() => openAuth("", "signin")} onProfile={() => setProfileOpen(true)} />

      <main id="main">
        <HeroSection onRegister={(phone) => openAuth(phone)} onSignin={() => openAuth("", "signin")} />
        <AboutSection />
        <PillarsGrid onSport={() => setSportOpen(true)} onLaunching={(p) => setLaunchPillar(p)} onNextGen={(p) => setNextGenPillar(p)} />
        <TournamentCalendar onOpenSport={() => setSportOpen(true)} />
        <InviteLeaderboard onShare={() => (user ? setProfileOpen(true) : openAuth())} />
        <OneIdSection onLogin={() => openAuth()} onSignin={() => openAuth("", "signin")} />
      </main>

      <Footer />

      <OneTalantaIDAuthModal open={authOpen} onOpenChange={setAuthOpen} prefillPhone={prefillPhone} initialMode={authMode} />
      <UserProfileModal open={profileOpen} onOpenChange={setProfileOpen} />
      <SportLiveEngineModal open={sportOpen} onOpenChange={setSportOpen} onLogin={() => openAuth()} />
      <LaunchingSoonModal open={!!launchPillar} onOpenChange={(o) => !o && setLaunchPillar(null)} pillar={launchPillar} />
      <NextGenPillarModal open={!!nextGenPillar} onOpenChange={(o) => !o && setNextGenPillar(null)} pillar={nextGenPillar} onLogin={() => openAuth()} />
      <BadgeCelebration unlock={unlock} onClose={clearUnlock} />
    </div>
  );
}
